/**
 * 多维分析和探索分析 公共的 图表组件
 */
export default {
  dbl_chart_statistical_metric: "统计指标",
  dbl_chart_select_placeholder: "请选择",
  dbl_chart_table: "表格",
  dbl_chart_line: "折线图",
  dbl_chart_bar: "柱状图",
  dbl_chart_switch: "图表切换",
  dbl_chart_pie: "饼状图",
  dbl_chart_compare: '对比项',
  dbl_chart_download: "下载",
  dbl_table_total: "共 {total} 项",
  dbl_table_total_more: "共 {total} 项，超过前端可展示上限，请下载数据后进行统计",


  dbl_chart_limit_info: '行限制 2000 行',
  dbl_chart_row_limit_info: '行限制',
  dbl_chart_row: '已超行数限制，结果可能不完整，更多数据请下载查看。',
  dbl_chart_row_over_limit: '已超过数据行限制，结果可能不完整。',
  dbl_chart_row_red_info: '已达到图表的行数限制。<br/>图表可能只显示部分数据。',
  dbl_chart_row_max_limit_info: '最多50000行',
  dbl_chart_modal_download_set: '下载设置',
  dbl_chart_modal_download_dataSource: '数据行数',
  dbl_chart_modal_download_warning: '单次下载上限100万行数据，建议通过筛选条件拆分任务后分批导出。',
  dbl_chart_limit_bubble: '系统对查询结果展示数有最大限制，至多展示2000条结果',
  dbl_chart_graph_settings: "图表配置",
  dbl_chart_top: "头部",
  dbl_chart_dynamic_series: "动态取值",
  dbl_chart_and_others: "和 其它",
  dbl_chart_only: "仅",
  dbl_chart_sort: "排序",
  dbl_chart_sort_by: "排序方式",
  dbl_chart_default_sorting: "系统默认排序",
  dbl_chart_custom_metric_sort: "指标",
  dbl_chart_dataset_field_sort: "字段排序",
  dbl_chart_dataset_field_sort_field: "字段",
  dbl_chart_dataset_field_sort_agg: "聚合方式",
  dbl_chart_dataset_field_sort_custom_group: "自定义字段",
  dbl_chart_dataset_field_sort_placeholder: "请选择",
  dbl_chart_low: "升序",
  dbl_chart_high: "降序",
  dbl_chart_confirm: "确认",
  dbl_chart_cancel: "取消",
  dbl_chart_metric: "指标",
  dbl_chart_axis: '手动排序',
  dbl_chart_mixed_tips: '新功能: Y轴配置可以在这里设置。',
  dbl_chart_primary_axis: '主Y轴',
  dbl_chart_secondary_axis: '次Y轴',
  dbl_chart_primary_name: 'Y轴名称',
  dbl_chart_xaxis_name: 'X轴名称',
  dbl_chart_primary_metic: '指标',
  dbl_chart_primary_chart_type: '图表类型',
  dbl_chart_dual_y_axis: '双Y轴',
  dbl_chart_dual_y_axis_min_metric_tip: '启用双Y轴至少需要 2 个指标',
  dbl_chart_dual_y_axis_metric_tip: '选择一侧后，另一侧会自动分配剩余指标',
  dbl_chart_dual_y_axis_metric_required: '需至少选择1个指标',
  dbl_chart_dual_y_axis_metric_allocation_required: '所有指标都需要分配到主/次Y轴',
  dbl_chart_primary_basic_info: '基本信息',
  dbl_chart_primary_basic_info_optional: '选填',
  dbl_chart_primary_field_setting: '字段设置',
  dbl_chart_field_column_sorting: '字段列排序',
  dbl_chart_primary_description: '描述',
  dbl_chart_primary_duplicate_name: '重复命名',
  dbl_chart_display_limit_info: '首个维度作为图形的X轴，基于第一个指标，其余维度值组合的展示数量可在此处设置',
  dbl_chart_stacked_limit_info: '首个维度作为图形的X轴，其余维度值组合的展示数量可在此处设置',
  dbl_chart_topN_info: '首个维度作为图形的{type}轴，{type}轴维度的展示数量可在此处设置',
  dbl_chart_axis_setting: '轴设置',
  dbl_chart_stacked_layer_display_limit: '堆叠层展示限制',
  dbl_chart_display_limit: '展示限制',
  dbl_chart_null_handing: '空值处理',
  dbl_chart_null_ui_label: '空值处理',
  dbl_chart_null_ui_break: '折线断开',
  dbl_chart_null_ui_zero: '设置为0',
  dbl_chart_null_ui_ignore: '忽略空值',
  dbl_chart_data_label: '数据标签',
  dbl_chart_show_values: '展示数值',
  dbl_chart_all_values: '全部数值',
  dbl_chart_none: '无',
  dbl_chart_show_7_values: '显示7个数值',
  dbl_chart_x_axis: 'X轴',
  dbl_chart_y_axis: 'Y轴',
  dbl_chart_yaxis_range_title: '显示范围：自动区间',
  dbl_chart_yaxis_range_tip: '根据查询结果的最小值和最大值自动计算Y轴刻度值',
  dbl_chart_field_setting_original: '原始值',
  dbl_chart_field_setting_url: '设置为URL',

  dbl_chart_description_edit_title: '编辑描述',
  dbl_chart_description_edit_waring: '清空内容则不显示描述',
  dbl_chart_description_edit_placeholder: '请输入内容',

  dbl_chart_statistics: '展示统计值',
  dbl_chart_statistics_placeholder: '请选择指标',
  dbl_chart_statistics_sum: '汇总值',
  dbl_chart_statistics_avg: '均值',
  dbl_chart_statistics_avgNotNull: '均值 (去空)',
  dbl_chart_statistics_max: '最大值',
  dbl_chart_statistics_min: '最小值',
  dbl_chart_statistics_sum_tooltip: '此列中所有数据的汇总值。',
  dbl_chart_statistics_avg_tooltip: '此列中所有数据的平均值，包括空值。',
  dbl_chart_statistics_avgNotNull_tooltip: '此列中所有数据的平均值，不包括空值。',
  dbl_chart_statistics_max_tooltip: '此列中所有数据的最大值。',
  dbl_chart_statistics_min_tooltip: '此列中所有数据的最小值。',

  // 参考线设置
  dbl_chart_config_tip_reference_lines: '新功能：参考线可以在这里设置。',
  dbl_chart_style: '样式',
  dbl_chart_advanced: '高级',
  dbl_chart_advanced_reference_line: '参考线',
  dbl_chart_advanced_add_reference_line: '添加参考线',
  dbl_chart_advanced_reference_line_index: '参考线 {count}',
  dbl_chart_advanced_reference_line_style: '样式',
  dbl_chart_advanced_reference_line_value: '数值',
  dbl_chart_advanced_reference_line_color: '颜色',
  dbl_chart_advanced_reference_line_label: '标签',
  dbl_chart_advanced_reference_line_label_placeholder: '请输入标签',
  dbl_chart_advanced_reference_line_dashed: '虚线',
  dbl_chart_advanced_reference_line_solid: '实线',
  dbl_chart_advanced_reference_line_fixed: '固定值',
  dbl_chart_advanced_reference_line_fixed_placeholder: '请输入数值',
  dbl_chart_advanced_reference_line_restore: '恢复设置',

  // 地图颜色设置
  dbl_chart_map_title: '颜色',
  dbl_chart_map_restore: '重置',
  dbl_chart_map_level1: '一级',
  dbl_chart_map_level2: '二级',
  dbl_chart_map_level3: '三级',
  dbl_chart_map_level4: '四级',
  dbl_chart_map_level5: '五级',
  dbl_chart_map_system_default: '系统预设颜色',
  dbl_chart_map_color_theme: '颜色主题',
  dbl_chart_map_color_blue: '蓝色',
  dbl_chart_map_color_yellow: '黄色',
  dbl_chart_map_color_green: '绿色',
  dbl_chart_map_color_red: '红色',
  dbl_chart_map_color_custom: '自定义',

  // x轴文本展示方式
  dbl_chart_x_label: '轴标签',
  dbl_chart_auto: '自动适应',
  dbl_chart_horizontal: '水平显示',
  dbl_chart_map_color_light: '浅色',
  dbl_chart_map_color_dark: '深色',
  dbl_chart_map_color1: '颜色一',
  dbl_chart_map_color2: '颜色二',
  dbl_chart_map_color3: '颜色三',
  dbl_chart_map_color4: '颜色四',
  dbl_chart_map_color5: '颜色五',

  // 词云图
  dbl_chart_count_limit: '词云展示数量限制',
  dbl_chart_count_limit_info: '在此设置展示指标最高的特定数量的关键词。',
  dbl_chart_count_limit_tip: '展示指标排名靠前的关键词',
  dbl_chart_color_setting_title: '颜色',
  dbl_chart_color_setting_restore: '重置',
  dbl_chart_color_setting_color_theme: '颜色主题',
  dbl_chart_color_setting_pure_color: '纯色',
  dbl_chart_color_setting_multi_color: '多色',
  dbl_chart_color_setting_sentiment_related: '依据情感分',
  dbl_chart_color_setting_count_related: '词频-首个指标',
  dbl_chart_color_setting_pure_color_tip: '纯色配色方案，颜色可选。',
  dbl_chart_color_setting_multi_color_tip: '多颜色配色方案，与字段无关。',
  dbl_chart_color_setting_sentiment_related_tip: '当拖入的第二个指标字段名称包含“Sentiment”时，该字段决定颜色。此外，该选项不可选。',
  dbl_chart_color_setting_count_related_tip: '拖入的第一个指标字段决定颜色。',
  dbl_chart_color_setting_sentiment_related_positive: '正面',
  dbl_chart_color_setting_sentiment_related_neutral: '中性',
  dbl_chart_color_setting_sentiment_related_negative: '负面',
  
  // 列总计占比
  dbl_chart_column_percent_title: '列总计占比',
  dbl_chart_column_percent_title_info: '请选择要显示的一个或多个指标，这些指标将以占总体的百分比形式展示。百分比指标将仅基于行限制范围内的数据计算。',
  dbl_chart_column_percent_placeholder: '请选择指标',

  // 维度占比（与后端 dimension_percentage 契约对齐）
  dbl_chart_dimension_percentage_title: '指定维度合计占比',
  dbl_chart_dimension_percentage_title_info: '勾选一个或多个维度作为聚合依据，再选择需要计算占比的指标；新增一列展示每行相对所选维度组合合计的占比。相同的维度组合值将作为一组单独计算。',
  dbl_chart_dimension_percentage_metric_index: '列总计占比 {count}',
  dbl_chart_dimension_percentage_metric_placeholder: '请选择',
  dbl_chart_dimension_percentage_metric_dropdown_title: '指标',
  dbl_chart_dimension_percentage_label: '标题名称',
  dbl_chart_dimension_percentage_label_placeholder: ' 请输入',
  dbl_chart_dimension_percentage_group_by_placeholder: '请选择',
  dbl_chart_dimension_percentage_group_by_dropdown_title: '维度',
  dbl_chart_dimension_percentage_add_metric: '添加',
  dbl_chart_group_by: '聚合维度',

  // 条件格式
  dbl_chart_conditional_formatting: "条件格式",
  dbl_chart_condition_batch_config_condition_format: "批量配置条件格式",
  dbl_chart_condition_bar_chart: "条形图",
  dbl_chart_condition_bar_chart_count: "条形图({count})",
  dbl_chart_condition_numerical: "数值",
  dbl_chart_condition_numerical_values: "数值({count})",
  dbl_chart_condition_select_metrics: "选择指标",
  dbl_chart_condition_select_metrics_placeholder: "请选择指标",
  dbl_chart_condition_merrics: "指标",
  dbl_chart_condition_color_theme: "颜色主题",
  dbl_chart_condition_solid_color: "纯色",
  dbl_chart_condition_gradient: "渐变色",
  dbl_chart_condition_color_blue: "蓝色",
  dbl_chart_condition_color_green: "绿色",
  dbl_chart_condition_color_yellow: "黄色",
  dbl_chart_condition_color_red: "红色",
  dbl_chart_condition_color_red_blue: "红-蓝",
  dbl_chart_condition_color_green_purple: "绿-紫",
  dbl_chart_condition_color_blue_cyan: "蓝-青",
  dbl_chart_condition_color_orange_red: "橙-红",
  dbl_chart_condition_color_purple_pink: "紫-粉",
  dbl_chart_condition_min: "最小值",
  dbl_chart_condition_max: "最大值",
  dbl_chart_condition_auto: "自动",
  dbl_chart_condition_custom_value: "自定义数值",
  dbl_chart_condition_custom_value_placeholder: "请输入数值",
  dbl_chart_condition_action: "操作",
  dbl_chart_condition_delete: "删除",
  dbl_chart_condition_restore_settings: "恢复设置",
  dbl_chart_condition_system_default: "系统预设颜色",
  dbl_chart_condition_max_less_than_min: "最大值不能小于最小值",

  // 表格条件格式 - 条形图（HorizontalBar）
  dbl_table_metric: "指标",
  dbl_table_condition_select_metrics: "选择指标",
  dbl_table_condition_select_metrics_placeholder: "请选择指标",
  dbl_table_condition_merrics: "指标",
  dbl_table_condition_rule: "规则",
  dbl_table_condition_color: "颜色",
  dbl_table_condition_icon: "图标",
  dbl_chart_condition_icon_change: "变化",
  dbl_chart_condition_icon_sentiment: "情感",
  dbl_chart_condition_icon_others: "其他",
  dbl_chart_condition_icon_none: "无",
  dbl_table_condition_color_theme: "颜色主题",
  dbl_table_condition_min: "最小值",
  dbl_table_condition_max: "最大值",
  dbl_table_condition_auto: "自动",
  dbl_table_condition_custom_value: "自定义数值",
  dbl_table_condition_custom_value_placeholder: "请输入数值",
  dbl_table_condition_action: "操作",
  dbl_table_condition_delete: "删除",
  dbl_table_condition_add_condition: "添加条件",
  dbl_table_condition_max_less_than_min: "最大值不能小于最小值",

  // 冻结窗格
  dbl_chart_freeze_panes: '冻结窗格',
  dbl_chart_freeze_panes_first: '冻结前',
  dbl_chart_freeze_columns: '列',
  dbl_chart_merge_same_cells: '合并相同单元格',

  // 数据标签显示
  dbl_chart_show_data_label: '显示数据标签',
  dbl_chart_display_form: '显示形式',
  dbl_chart_adaptive: '自适应',
  dbl_chart_adaptive_tips: '重叠时隐藏',
  dbl_chart_all: '全部',
  dbl_chart_label_content: '标签内容',
  dbl_chart_label_content_placeholder: '请选择标签内容',
  dbl_chart_label_metric: '指标',
  dbl_chart_dimension: '维度',
  dbl_chart_percentage: '百分比',
  dbl_chart_total: '总计',

  // 浮窗配置
  dbl_chart_tooltip: '工具提示',
  dbl_chart_tooltip_total: '总计',
  dbl_chart_tooltip_share: '占比',
  dbl_chart_tooltip_add: '添加',
  dbl_chart_tooltip_extra_title: '添加额外内容',
  dbl_chart_tooltip_extra_title_edit: '编辑额外内容',
  dbl_chart_tooltip_extra_insert_field: '插入字段',
  dbl_chart_tooltip_extra_search_field: '搜索字段名称',
  dbl_chart_tooltip_extra_clear_all: '全部清除',
  dbl_chart_tooltip_extra_preview: '预览',
  dbl_chart_tooltip_extra_preview_title: 'Tooltip 预览',
  dbl_chart_tooltip_extra_add_text: '添加文案',
  dbl_chart_tooltip_extra_text_placeholder: '请输入固定文案',
  dbl_chart_tooltip_extra_empty_tip: '暂无内容，可添加固定文案或插入字段。',
  dbl_chart_tooltip_extra_selected: '已选择',
  /** Tooltip 额外内容：下拉中已插入的字段行尾状态 */
  dbl_chart_tooltip_extra_added: '已添加',
  dbl_chart_tooltip_extra_delete_title: '删除额外内容',
  dbl_chart_tooltip_extra_delete_confirm: '删除后 Tooltip 将不再展示额外内容，是否继续？',
  dbl_chart_tooltip_extra_info_tip: '添加额外内容: 支持固定文案或维度字段。',
  
  // 设置成功提示
  dbl_chart_config_success: '配置保存成功！',
  
  // Legend配置
  dbl_chart_legend_setting: '图例',
  dbl_chart_legend_color_search: '搜索图例名称',
  dbl_chart_legend_position: '位置',
  dbl_chart_legend_position_below: '下方',
  dbl_chart_legend_position_above: '上方',
  dbl_chart_legend_position_hide: '隐藏',
  // Pivot / Crosstab
  dbl_chart_pivot_crosstab_setting: '透视表（交叉表）',
  dbl_chart_pivot_row: '行',
  dbl_chart_pivot_column: '列',
  dbl_chart_pivot_available: '可选字段',
  dbl_chart_pivot_selected: '已选字段',
};